import type { Directive, DirectiveBinding } from 'vue'
import { useUserStore } from '@/store/modules/user'
import { hasAnyPermission } from '@/utils/permission'
import type { PermissionCode } from '@/constants'

/**
 * v-permission 指令：用法
 *   <el-button v-permission="PERMISSION_CODES.USER_MANAGE">删除</el-button>
 *   <el-button v-permission="[CODE_A, CODE_B]">操作</el-button>
 *
 * 当当前用户权限码不命中 required 时，移除该 DOM 节点。
 */
function update(
  el: HTMLElement,
  binding: DirectiveBinding<PermissionCode | PermissionCode[] | undefined>
) {
  const codes = useUserStore().permissionCodes
  if (!hasAnyPermission(binding.value, codes)) {
    el.parentNode?.removeChild(el)
  }
}

export const permissionDirective: Directive<
  HTMLElement,
  PermissionCode | PermissionCode[] | undefined
> = {
  mounted: update,
  updated: update
}